module.exports = "<a class=\"btn btn-default btn-xs\" ng-click=loginas()>Login as this user</a>";


//////////////////
// WEBPACK FOOTER
// ./js/actions/loginas.html
// module id = 435
// module chunks = 0